import { hasLocalStorage } from '../../common/helpers/window';

/** Dedicated key; do not reuse other modals' keys (e.g. jlsc). */
export const LTP_CONSENT_STORAGE_KEY = 'wb-us-ltp-consent-v1';

/** ISO-8601 instant when the user clicked Agree (for receipts / restored events). */
export const LTP_CONSENT_TIMESTAMP_KEY = 'wb-us-ltp-consent-ts-v1';

export const hasLtpConsent = (): boolean => {
  if (!hasLocalStorage()) {
    return false;
  }
  try {
    return localStorage.getItem(LTP_CONSENT_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export const setLtpConsent = (): void => {
  if (!hasLocalStorage()) {
    return;
  }
  try {
    localStorage.setItem(LTP_CONSENT_STORAGE_KEY, '1');
    localStorage.setItem(LTP_CONSENT_TIMESTAMP_KEY, new Date().toISOString());
  } catch {
    // ignore
  }
};

export const getLtpConsentTimestamp = (): string | undefined => {
  if (!hasLocalStorage()) {
    return undefined;
  }
  try {
    const raw = localStorage.getItem(LTP_CONSENT_TIMESTAMP_KEY);
    return raw && raw.length > 0 ? raw : undefined;
  } catch {
    return undefined;
  }
};
